/* RESPONSIBLE TEAM: team-reporting */

import { COLOR_MAPPINGS } from '@/features/reporting-charts/constants';

/**
 * Returns the fixed color for a known dimension+value pair, or undefined.
 * When undefined, Highcharts' default palette cycling handles coloring.
 */
export function getSeriesColor(
  dimension: string | undefined,
  rawValue: string,
): string | undefined {
  if (!dimension) return undefined;
  return COLOR_MAPPINGS[dimension]?.[rawValue];
}
